const initialState = {
  HomePage: {
    SelectedPage: 0
  },
  AboutPage: {
    Loading: false
  },
  SkillPage: {
    Loading: false
  },
  MyWorkPage: {
    Loading: false
  },
  ContactMePage: {
    Loading: false
  },
  NavBarLoginText: {
    NavBarText: 'Login',
    Login: false
  },
  LoggedInPage: {
    SelectedPage: 0
  }
}

export default function Reducer(state = initialState, { type, payload }) {
  switch (type) {
    case 'SelectedPage':
      return { ...state, HomePage: payload }

    case 'AboutPageLoading':
      return { ...state, AboutPage: payload }

    case 'SkillPageLoading':
      return { ...state, SkillPage: payload }

    case 'MyWorkPageLoading':
      return { ...state, MyWorkPage: payload }

    case 'ContactPageLoading':
      return { ...state, ContactMePage: payload }

    case 'ZeroValues':
      return { ...state, AboutPage: payload, SkillPage: payload, MyWorkPage: payload, ContactMePage: payload }

    case 'NavBarLoginText':
      return { ...state, NavBarLoginText: payload }

    case 'LoggedInPage':
      return { ...state, LoggedInPage: payload }

    default:
      return state
  }
}
